export const STORYBLOK_IMAGE_FORMAT = "webp";

type FacilityMediaBlok = {
  component?: string;
  asset?: {
    filename?: string;
    is_external_url?: boolean;
  };
  poster?: {
    filename?: string;
  };
  youtube_link?: string;
};

type StoryblokImageTransformOptions = {
  width?: number | string;
  height?: number | string;
  format?: string;
};

export const normalizeStoryblokAssetUrl = (
  filename?: string | null
): string | null => {
  if (!filename) return null;

  const url = filename.replace(/s3\.amazonaws\.com\//, "");
  if (!url.includes("storyblok.com")) return null;

  return url;
};

export const buildStoryblokImageUrl = (
  filename?: string | null,
  { width = 0, height = 0, format = STORYBLOK_IMAGE_FORMAT }: StoryblokImageTransformOptions = {}
): string | null => {
  const normalized = normalizeStoryblokAssetUrl(filename);
  if (!normalized) return null;

  const size =
    width || height ? `${width}x${height}` : "0x0";
  const filters = format ? `filters:format(${format})` : "";

  return `${normalized}/m/${size}${filters ? `/${filters}` : ""}`;
};

export const getFacilityCarouselImageFilename = (
  blok?: FacilityMediaBlok | null
): string | null => {
  if (!blok) return null;

  if (blok.component === "asset-image") {
    if (blok.asset?.is_external_url) return null;
    return blok.asset?.filename ?? null;
  }

  if (blok.youtube_link) {
    return blok.poster?.filename ?? null;
  }

  if (blok.asset?.is_external_url) return null;
  return blok.asset?.filename ?? blok.poster?.filename ?? null;
};
